import { PLAN_REVIEW_JUSTIFICATION_MIN_LENGTH } from '../config/justification'

export const isPlanReviewJustificationValid = (value?: string) =>
  (value?.trim().length ?? 0) >= PLAN_REVIEW_JUSTIFICATION_MIN_LENGTH
